module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightCond.c205727.ttf";